import { render } from "./DownloadTemplateModal.vue?vue&type=template&id=524910d4&scoped=true"
import script from "./DownloadTemplateModal.vue?vue&type=script&lang=js"
export * from "./DownloadTemplateModal.vue?vue&type=script&lang=js"

import "./DownloadTemplateModal.vue?vue&type=style&index=0&id=524910d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524910d4"]])

export default __exports__